import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareOnboardingGetStartedRoute } from '@atlassian/jira-router-routes-software-onboarding-routes/src/softwareOnboardingGetStartedRoute.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { softwareOnboardingGetStartedEntrypoint } from '@atlassian/jira-spa-apps-onboarding-get-started/entrypoint.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { softwareOnboardingGetStartedIntegrationsStatusResource } from '@atlassian/jira-router-resources-jsw-onboarding/src/services/get-started-integrations-status/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectContextResourceWithCache } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { fetchUserTraitsResource } from '@atlassian/jira-router-resources-personalization/src/services/fetch-user-traits/index.tsx';

const softwareOnboardingGetStartedPageEntrypoint = createPageEntryPoint({
	main: softwareOnboardingGetStartedEntrypoint,
});

export const softwareOnboardingGetStartedRouteEntry: Route = createEntry(
	softwareOnboardingGetStartedRoute,
	() => ({
		group: 'software',
		entryPoint: () =>
			fg('jira_get_started_route')
				? softwareOnboardingGetStartedPageEntrypoint
				: notFoundPageEntrypoint,
		layout: softwareProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			// horizontal: AsyncHorizontalNavJira,
			// onlyShowHorizontalOnNav4: true,
		},
		resources: [
			...getNavigationResources(),
			fetchUserTraitsResource,
			projectContextResourceWithCache,
			softwareOnboardingGetStartedIntegrationsStatusResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-software-onboarding-entries/src/softwareOnboardingGetStartedRouteEntry.tsx',
				whichExportToUse: 'softwareOnboardingGetStartedRouteEntry',
			},
			enabled: true,
		},
		canTransitionIn: () => true,
	}),
);
